<template>

    <div class="uk-grid-divider uk-child-width-1-1 uk-child-width-1-2@m" uk-grid>

        <div v-if="feedback_id === null">
            <div class="uk-grid-small" uk-grid>

                <div class="uk-width-1-1 uk-flex uk-flex-right uk-hidden@m">
                    <div>
                        <a href="#text" class="uk-button uk-button-primary uk-position-relative tm-button-with-icon" @click="scroll($event)">Подробная информация<span class="uk-position-center-right" style="margin-right: 31px;color: #41652d;" uk-icon="icon: triangle-left;"></span><div class="uk-position-center-right" style="background-color: #41652d;"><span uk-icon="icon: info"></span></div></a>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">Базовая модель трансформатора</label>

                    <div class="uk-form-controls">
                        <input class="uk-input" v-model="formData.winding.base_model" type="text">
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">U<sub>вх.</sub> входное напряжение, <b>В</b></label>

                    <div class="uk-form-controls">
                        <input class="uk-input" v-model="formData.winding.u_in" type="text">
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">P<sub>макс.</sub> максимальная выходная мощность, <b>Вт</b></label>

                    <div class="uk-form-controls">
                        <input class="uk-input" v-model="formData.winding.p_max" type="text">
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">N<sub>2</sub> количество вторичных обмоток</label>

                    <div class="uk-form-controls">
                        <select @change="addWindingParam" v-model="formData.winding.n_two" class="uk-select">
                            <option v-for="option in windingData.n_two" :value="option">{{ option }}</option>
                        </select>
                    </div>
                </div>
                <div class="uk-width-1-1" v-for="(item,key,index) in formData.winding.winding_params" :key="key">
                    <div class="uk-width-1-1">
                        <label class="uk-form-label">U<sub>вых.ном.{{ key + 1 }}</sub> выходное напряжение в режиме
                            номинальной нагрузки, <b>В</b></label>

                        <div class="uk-form-controls">
                            <div class="uk-form-controls">
                                <input class="uk-input" v-model="item.u_out" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-1">
                        <label class="uk-form-label">I<sub>ном.{{ key + 1 }}</sub> ток номинальной нагрузки,
                            <b>А</b></label>

                        <div class="uk-form-controls">
                            <div class="uk-form-controls">
                                <input class="uk-input" v-model="item.i" type="text">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-1 uk-width-1-2@s">
                    <label class="uk-form-label">Климатическое исполнение</label>

                    <div class="uk-form-controls">
                        <select v-model="formData.winding.climate" class="uk-select">
                            <option v-for="option in windingData.climate" :value="option">{{ option }}</option>
                        </select>
                    </div>
                </div>
                <div class="uk-width-1-1 uk-width-1-2@s">
                    <label class="uk-form-label">Тип монтажа</label>

                    <div class="uk-form-controls">
                        <select v-model="formData.winding.install_type" class="uk-select">
                            <option v-for="option in windingData.install_type" :value="option">{{ option }}</option>
                        </select>
                    </div>
                </div>
                <div class="uk-width-1-1">
                    <label class="uk-form-label">Требуемое количество трансформаторов</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" v-model="formData.winding.count" type="text">
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">Примечание</label>
                    <div class="uk-form-controls">
                        <textarea v-model="formData.ShopFeedback.message" class="uk-textarea" rows="3"></textarea>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">Ваше имя</label>
                    <div class="uk-form-controls">
                        <input :class="{' uk-form-danger': errors.has('customer')}"
                               v-validate="{required: true, alpha: true }" name="customer"
                               placeholder="Ваше имя" v-model="formData.ShopFeedback.customer" class="uk-input"
                               type="text">
                    </div>
                </div>

                <div class="uk-width-1-1 uk-width-1-2@s">
                    <label class="uk-form-label">Телефон</label>
                    <div class="uk-form-controls">
                        <input placeholder="Ваш телефон*" :class="{' uk-form-danger': errors.has('phone')}"
                               v-validate="{ required: true, regex: /^([0-9\s\-\+\(\)]{7,})$/ }"
                               v-model="formData.ShopFeedback.phone" name="phone" class="uk-input" type="tel">
                    </div>
                </div>
                <div class="uk-width-1-1 uk-width-1-2@s">
                    <label class="uk-form-label">Удобное время для звонка</label>
                    <div class="uk-form-controls">
                        <input placeholder="С 10 до 18" name="time"
                               v-model="formData.ShopFeedback.time"
                               class="uk-input" type="text">
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <label class="uk-form-label">Email</label>
                    <div class="uk-form-controls">
                        <input placeholder="Ваш e-mail" :class="{' uk-form-danger': errors.has('email')}"
                               v-validate="{ required: true, email: true }" name="email"
                               v-model="formData.ShopFeedback.email" class="uk-input" type="email">
                    </div>
                </div>

                <div class="uk-width-1-1 uk-text-center">
                    <button @click.prevent="send" class="uk-button uk-button-primary uk-margin-xsmall-top">Отправить
                    </button>
                </div>

            </div>
            <div v-show="loading" class="uk-overlay-default uk-position-cover">
                <div class="uk-position-center">
                    <div uk-spinner="ratio: 3"></div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="uk-grid-small" uk-grid>

                <div class="uk-width-1-1">
                    <p>Заявка № {{ feedback_id }} успешно отправлена.</p>
                </div>
            </div>
        </div>

        <div id="text" v-html="ShopPage.text"></div>

    </div>


</template>

<script>
    export default {
        name: "Winding",
        props: {
            ShopPage: {
                type: Object,
            },
            BaseModel: {
                type: String,
                default: ''
            },
            ModalWindow: {
                type: Boolean,
                default() {
                    return false
                }
            },
            properties: {
                type: [Array, Object],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                loading: false,
                feedback_id: null,
                formData: {
                    ShopFeedback: {
                        customer: '',
                        phone: '',
                        email: '',
                        time: '',
                        message: '',
                    },
                    winding: {
                        base_model: this.BaseModel,
                        u_in: '',
                        p_max: '',
                        n_two: '',
                        climate: '',
                        install_type: '',
                        count: '',
                        winding_params: []
                    }
                },
                windingData: {
                    n_two: [
                        1, 2, 3, 4, 5, 6
                    ],
                    climate: [
                        'не выбрано',
                        'герметизированное',
                        'открытое',
                    ],
                    install_type: [
                        'не выбрано',
                        'навесной',
                        'печатный',
                    ]

                }
            }
        },
        computed: {
            pmax() {
                return this.properties.find((property) => {
                    return property.ShopPropertyValue.property_id === 3;
                }).ShopPropertyValue
            },
            climate() {
                return this.properties.find((property) => {
                    return property.ShopPropertyValue.property_id === 11;
                }).ShopPropertyValue
            },
            installtype() {
                return this.properties.find((property) => {
                    return property.ShopPropertyValue.property_id === 12;
                }).ShopPropertyValue
            }
        },
        created(){
            this.bindParams()
        },
        methods: {
            bindParams() {
                if (this.BaseModel !== '') {
                    this.formData.winding.p_max = this.pmax.value_varchar ? this.pmax.value_varchar : '';
                    this.formData.winding.climate = this.climate.value_varchar ? this.climate.value_varchar : '';
                    this.formData.winding.install_type = this.installtype.value_varchar ? this.installtype.value_varchar : '';
                }
            },
            addWindingParam() {
                this.formData.winding.winding_params = [];

                const size = Array.apply(null, Array(this.formData.winding.n_two));
                size.forEach((item) => {
                    this.formData.winding.winding_params.push({
                        u_out: '',
                        i: ''
                    })
                })
            },
            send() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true;
                        this.$http.post('/feedback/send', this.formData).then(response => {
                            this.feedback_id = response.body.data.id;
                            this.loading = false;
                        }, response => {
                        })
                    }

                });

            },
            scroll(event) {
                var target = $(event.target).attr("href");
                var padding = parseInt($('#winding').css("padding-top"));
                if(this.ModalWindow == true){
                    $('#winding').animate({ scrollTop: ($(target).position().top + padding + 20) }, 1000);
                }else{
                    $('html, body').animate({ scrollTop: ($(target).position().top + 20) }, 1000);
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Winding.vue?421a0232